export enum TimeFormat {
  'HH:mm',
  'hh:mm a'
}
